import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

export default class ExperienceBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    console.error('Page experience error', error, info);
  }

  componentDidUpdate(previousProps) {
    if (previousProps.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="experience-error-state">
        <span><AlertTriangle size={25} /></span>
        <h1>This page needs a quick refresh</h1>
        <p>Your catalog data is safe. Retry the page, or return to the dashboard and continue working.</p>
        <div><button onClick={() => window.location.reload()}><RefreshCw size={15} /> Retry page</button><button onClick={() => { window.location.href = '/dashboard'; }}><Home size={15} /> Go to dashboard</button></div>
      </div>
    );
  }
}
